@if (isScheduled) {
  <div class="text-center">
    <button mat-icon-button [matMenuTriggerFor]="menu" matTooltip="Options">
      <mat-icon>more_horiz</mat-icon>
    </button>
  </div>

  <mat-menu #menu="matMenu">
    <button mat-menu-item data-testid="cancel-scheduled-rate-button" (click)="cancelScheduledRate()">
      <mat-icon>cancel</mat-icon>
      <span>Cancel Scheduled Change</span>
    </button>
  </mat-menu>
}
